<template>
  <div class="poseie">
    <v-container>
      <v-sheet
        :color="color"
        height="100%"
        tile
      >
        <v-container fluid>
          <v-layout column>
            <v-flex xs12>
              <div>
                <v-layout
                  justify-center
                  justify-space-between
                  align-top
                >
                  <div class="item elevation-5">
                    <v-layout
                      d-flex
                      column
                    >
                      <v-btn
                        class="ma-2"
                        color="primary"
                        dark
                        @click="rand"
                      >
                        Une poésie au hasard
                      </v-btn>
                      <v-btn
                        class="ma-2"
                        color="primary"
                        dark
                        @click="prev"
                      >
                        <v-icon
                          x-large
                          color="purple darken-2"
                        >
                          mdi-chevron-left
                        </v-icon>
                      </v-btn>
                      <v-layout
                        d-flex
                        row
                      >
                        <v-text-field
                          v-model="filter"
                          placeholder="Rechercher"
                          prepend-icon="mdi-search-web"
                        />
                        <v-btn
                          class="ma-2"
                          color="primary"
                          dark
                          @click="search"
                        >
                          OK
                        </v-btn>
                      </v-layout>
                    </v-layout>
                  </div>
                  <div
                    class="item elevation-5"
                    v-if="index>=0 & index<pageContent.length"
                  >
                    <v-card
                      max-width="600"
                      class="mx-auto"
                    >
                      <v-card-title class="poesie-titre">
                        {{ pageContent[index].titre }}
                      </v-card-title>
                      <v-card-text class="poesie-texte">
                        {{ pageContent[index].poeme }}
                      </v-card-text>
                      <v-card-text class="poesie-auteur">
                        {{ pageContent[index].auteur }}
                      </v-card-text>
                    </v-card>
                  </div>
                  <div v-else>
                    Aucun résultat
                  </div>
                  <div class="item elevation-5">
                    <v-btn
                      class="ma-2"
                      color="primary"
                      dark
                      @click="next"
                    >
                      <v-icon
                        x-large
                        color="purple darken-2"
                      >
                        mdi-chevron-right
                      </v-icon>
                    </v-btn>
                  </div>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-sheet>
    </v-container>
  </div>
</template>

<script>
import { storage, Storage } from "@/storage";
import store from "@/store";
import EventBus from "@/eventBus";
export default {
  name: "Poesie",
  created: function() {
    this.pageLoaded = store.state.pageContent;
    store.dispatch("loadPage", {page:this.page});
  },
  mounted:function() {
    EventBus.$on("page:loaded", event => {
      this.pageContent = event;
      this.index=(event!=null && event.length>0)
      ?Math.floor(Math.random() * event.length)
      :null;
    })
  },
  computed: {},
  props: {},
  data() {
    return {
      filter:"",
      color:'pink',
      index:-1,
      expanded: [],
      singleExpand: true,
      itemsPerPageOptions: [4, 8, 12],
      itemsPerPage: 4,
      page : 'poesie',
      pageContent: [],
    };
  },
  methods: {
    login() {
      store.dispatch("loadPage", {page:this.page});
    },
    next (){
      this.index++;
      this.index= this.index>=this.pageContent.length?0:this.index; 
    },
    prev (){
      this.index--; 
      this.index= this.index<0?(this.pageContent.length-1):this.index; 
    },
    rand (){
      this.index = Math.floor(Math.random() * this.pageContent.length)
    },
    search (){
      store.dispatch("loadPage", {page:this.page, action: "search", params:{name:this.filter}});
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.poesie-titre {
  font-size: 2em;
  text-align: center;
  margin-top:5px;
  border-top:solid 2px blue
}
.poesie-texte {
  font-size: 1.5em;
  white-space:pre-wrap;
  padding-left:40px;
  word-wrap: break-word;
}
.poesie-auteur {

}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
